module.exports = __webpack_public_path__ + "static/media/S1N3.56b33798.svg";